import { useRouter } from "next/router";
import Text from "../atoms/Text";
import MerchantCard from "../molecules/MerchantCard";
import React from "react";

const CategoryInfoView = ({ categoryTitle, merchantCard, swiperRef, ...property }) => {
    const router = useRouter();
    return (
        <div className={`relative w-full pt-6 ${property.className}`}>
            <div className="flex justify-between mb-3">
                <Text variant="large" className="text-neutral-800">
                    {categoryTitle}
                </Text>
            </div>
            <div className="flex flex-col gap-2">
                {merchantCard.map((merchant, index) => (
                    <MerchantCard
                        key={index}
                        className="flex-grow"
                        image={merchant.logo}
                        time={"Ends: Ongoing"}
                        cashbackPercentage={`Up to ${merchant.cashback / 100}% cashback`}
                        name={merchant.name}
                        onClick={() => {
                            router.push(`/merchants/${merchant.name}/${merchant.id}`);
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

export default CategoryInfoView;
